import React from "react";
import { object, string, node, func, oneOf } from "prop-types";
import classNames from "classnames";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorIcon from "@material-ui/icons/Error";
import InfoIcon from "@material-ui/icons/Info";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import Snackbar from "@material-ui/core/Snackbar";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import WarningIcon from "@material-ui/icons/Warning";
import { withStyles } from "@material-ui/core/styles";
import { inject, observer } from "mobx-react";
import { flowRight } from "lodash";

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon
};

const styles1 = theme => ({
  success: {
    backgroundColor: "green"
  },
  error: {
    backgroundColor: "red"
  },
  info: {
    backgroundColor: "blue"
  },
  warning: {
    backgroundColor: "orange"
  },
  icon: {
    fontSize: 20
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: "5px"
  },
  message: {
    fontFamily: "Muli, Helvetica",
    display: "flex",
    alignItems: "center"
  }
});

const MySnackbarContent = ({
  classes,
  className,
  message,
  onClose,
  variant,
  ...other
}) => {
  const Icon = variantIcon[variant];

  return (
    <SnackbarContent
      className={classNames(classes[variant], className)}
      aria-describedby="client-snackbar"
      message={
        <span id="client-snackbar" className={classes.message}>
          <Icon className={classNames(classes.icon, classes.iconVariant)} />
          {message}
        </span>
      }
      action={[
        <IconButton
          key="close"
          aria-label="Close"
          color="inherit"
          className={classes.close}
          onClick={onClose}
        >
          <CloseIcon className={classes.icon} />
        </IconButton>
      ]}
      {...other}
    />
  );
};

MySnackbarContent.propTypes = {
  classes: object.isRequired,
  className: string,
  message: node,
  onClose: func,
  variant: oneOf(["success", "warning", "error", "info"]).isRequired
};

const MySnackbarContentWrapper = withStyles(styles1)(MySnackbarContent);

const styles2 = theme => ({
  margin: {
    margin: "10px"
  }
});

const AppSnackbar = ({ CommonStore }) => {
  const {
    snackbarShouldOpen,
    snackbarVariant,
    snackbarMessage,
    closeAppSnackbar,
    snackbarDuration
  } = CommonStore;

  const isMobile = window.innerWidth <= 500;

  const anchorOrigin = {
    vertical: isMobile ? "bottom" : "top",
    horizontal: isMobile ? "center" : "center"
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    closeAppSnackbar();
  };

  return (
    <Snackbar
      anchorOrigin={anchorOrigin}
      open={snackbarShouldOpen}
      autoHideDuration={snackbarDuration}
      onClose={handleClose}
    >
      <MySnackbarContentWrapper
        onClose={handleClose}
        variant={snackbarVariant} // error, warning, info, success
        message={snackbarMessage}
      />
    </Snackbar>
  );
};

export default flowRight(
  withStyles(styles2),
  inject("CommonStore"),
  observer
)(AppSnackbar);
